<template>
  <v-container fluid class="pa-0">
    <EditLocationNameDialog ref="editLocationNameDialog" />

    <v-card>
      <v-layout class="align-baseline">
        <div class="key-content font-weight-medium pl-3 pr-1 py-2">
          Location Name
        </div>
        <v-flex class="grey--text text--darken-3">
          {{ displayName }}
        </v-flex>
        <v-spacer />
        <div class="action-content" v-if="editForm">
          <v-tooltip :open-delay="500" right>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="editMFDisplayName()" icon>
                <v-icon color="warning">edit</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Button.Edit") }}</span>
          </v-tooltip>
        </div>
      </v-layout>

      <v-layout class="align-baseline">
        <div class="key-content font-weight-medium pl-3 pr-1 py-2">
          Data Types
        </div>
        <v-flex class="grey--text text--darken-3">
          <v-chip v-for="(dataType, index) in dataTypes" :key="`dataType-${index}`" small>
            {{ dataType }}
          </v-chip>
          <v-chip v-if="dataTypes.length === 0" outline color="error" label small>
            No data types
          </v-chip>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
  import EditLocationNameDialog from './EditLocationNameDialog'

  import {
    SOURCE_TYPES_WITH_NAME,
  } from '@/store/MonitoringFeature/monitoringfeature'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  export default {
    components: {
      EditLocationNameDialog,
    },
    props: {
      editForm: Boolean,
    },
    computed: {
      ...monitoringFeatures.mapGetters([
        'currentFeatureDataSourceData',
        'currentFeatureDataSourceIndexByType',
        'currentMonitoringFeature',
        'getDisplayName',
      ]),
      displayName() {
        return this.getDisplayName(this.currentMonitoringFeature)
      },
      sourceTypesIndex() {
        let index = {}
        SOURCE_TYPES_WITH_NAME.forEach(sourceType => index[sourceType.key] = sourceType)
        return index
      },
      dataTypes() {
        return this.currentMonitoringFeature.FeatureDataSources.map(fds =>
          this.sourceTypesIndex[fds.SourceType].dataType)
      },
    },
    methods: {
      editMFDisplayName() {
        this.$refs.editLocationNameDialog.show(this.currentMonitoringFeature)
      },
    },
  }
</script>